'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.watchHandleUnauthorizedRequest = watchHandleUnauthorizedRequest;

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _Login = require('containers/Login/Login.js');

var _Login2 = _interopRequireDefault(_Login);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _modals = require('constants/modals.js');

var _auth = require('redux/modules/auth.js');

var _modals2 = require('redux/modules/modals.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(handleUnauthorizedRequest),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(watchHandleUnauthorizedRequest);

// Constants -------------------------------------------------------------------

// Action Creators -------------------------------------------------------------

// Sagas -----------------------------------------------------------------------

function modalAlreadyShowing() {
  return false;
}

function handleUnauthorizedRequest() {
  return _regenerator2.default.wrap(function handleUnauthorizedRequest$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!modalAlreadyShowing()) {
            _context.next = 2;
            break;
          }

          return _context.abrupt('return');

        case 2:
          _context.next = 4;
          return (0, _effects.put)((0, _modals2.show)(_modals.LOGIN, {
            isBasic: true,
            children: _react2.default.createElement(_Login2.default)
          }));

        case 4:
          _context.next = 6;
          return (0, _effects.take)(_auth.LOGIN.SUCCESS);

        case 6:
          _context.next = 8;
          return (0, _effects.put)((0, _modals2.hide)(_modals.LOGIN));

        case 8:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function failedWithErrorCode(code) {
  return function (action) {
    return action.error && action.error.status === code;
  };
}

/* eslint-disable import/prefer-default-export */
function watchHandleUnauthorizedRequest() {
  return _regenerator2.default.wrap(function watchHandleUnauthorizedRequest$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _reduxSaga.takeEvery)(failedWithErrorCode(403), handleUnauthorizedRequest);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}
/* eslint-enable import/prefer-default-export */


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/unauthorized.js
// module id = 1665
// module chunks = 0